import { render, staticRenderFns } from "./SalesApplicationPersonalDetailsStepOverview.vue?vue&type=template&id=1754b50b&"
import script from "./SalesApplicationPersonalDetailsStepOverview.vue?vue&type=script&lang=ts&"
export * from "./SalesApplicationPersonalDetailsStepOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports